import { createSlice } from '@reduxjs/toolkit';
import { allusersApi } from './allusersApi';

const initialState = {
    allusers: [],
    loading: false,
    error: null,
};

const allusersSlice = createSlice({
    name: 'allusers',
    initialState,
    reducers: {
        setAllUsers: (state, action) => {
            state.allusers = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
        .addMatcher(allusersApi.endpoints.getallusers.matchPending, setLoading)
        .addMatcher(allusersApi.endpoints.getallusers.matchRejected, setError)
        .addMatcher(allusersApi.endpoints.getallusers.matchFulfilled, (state, action) => {
            console.log("All users fetched:", action.payload);
            state.allusers = action.payload.data || [];
            state.loading = false;
            state.error = null;
        });
    },
});

export const { setAllUsers, setLoading, setError } = allusersSlice.actions;
export default allusersSlice.reducer;